import React, {createContext, useMemo} from 'react';
import PropTypes from 'prop-types';
import {Redirect, useParams, useLocation} from 'react-router-dom';
import useGetProductListProductsBySlug from '../../hooks/useGetProductListProductsBySlug';
import useGetProductListHeroBySlug from '../../hooks/useGetProductListHeroBySlug';
import {REGISTRY_AWARDS_SLUG} from '../../constants';
import useTKRSPage from '../../hooks/useTKRSPage';

const TKRS_HOMEPAGE_SLUG = 'tkrs-homepage';

const defaultValue = {
  productList: null,
  isLoading: true,
};

const Context = createContext(defaultValue);

export default Context;

export const ContentContextProvider = ({children}) => {
  const {pathname} = useLocation();
  const {id: slugParam} = useParams();
  const {isCollectionPLP, isInterestPLP} = useTKRSPage();

  const isHomePage = pathname === '/';
  const slug = isHomePage ? TKRS_HOMEPAGE_SLUG : slugParam;
  // we want the award field whenever it's not on the registry-awards collection
  const includeAward = slugParam !== REGISTRY_AWARDS_SLUG;
  const {
    data: productListHero,
    isLoading: isLoadingProductListHero,
  } = useGetProductListHeroBySlug(slug);
  const {
    isLoading: isLoadingProductListProducts,
    data: productList,
  } = useGetProductListProductsBySlug({
    includeAward,
    slug,
    skip: isLoadingProductListHero || isHomePage,
  });

  const values = useMemo(
    () => ({
      productList: {
        ...(productList || {}),
        ...(productListHero || {}),
        slug,
      },
      isLoadingProductListProducts,
      isLoadingProductListHero,
    }),
    [
      productList,
      isLoadingProductListProducts,
      isLoadingProductListHero,
      productListHero,
      slug,
    ],
  );

  if (!isLoadingProductListHero) {
    if (isCollectionPLP && productListHero?.type === 'interest') {
      return <Redirect to={`/interests/${slugParam}`} />;
    }

    if (isInterestPLP && productListHero?.type === 'collection') {
      return <Redirect to={`/collections/${slugParam}`} />;
    }
  }

  return <Context.Provider value={values}>{children}</Context.Provider>;
};

ContentContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
